// import store from '_root/store'
import sessionService from '@/app/services/common/sessionService';
// test if user is logged
export default (to, from, next) => {
  const user = sessionService.getLocalData('_user');

  if (user.settings.user_type_id === 1) {
    next();
  } else {
    next('/admin/overview');
  }
};
